import { GenIcon } from 'react-icons';
export const MdCurrencyFlagRon = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_21686_30736)' },
            child: [
                {
                    tag: 'path',
                    attr: {
                        d: 'M23.6602 11.7637C23.6602 6.54817 20.3172 2.10196 15.6584 0.449219V23.0782C20.3172 21.4281 23.6602 16.9766 23.6602 11.7611V11.7637Z',
                        fill: '#DB1300',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M11.6628 23.7623C13.0637 23.7623 14.4114 23.5208 15.6611 23.0778V0.448813C14.4114 0.00578301 13.0637 -0.238281 11.6628 -0.238281C10.262 -0.238281 8.91154 0.00578301 7.66193 0.448813V23.0778C8.91154 23.5208 10.2593 23.7623 11.6628 23.7623Z',
                        fill: '#FFCE22',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M7.66191 0.449219C3.00305 2.09931 -0.339844 6.54817 -0.339844 11.7637C-0.339844 16.9793 3.00305 21.4281 7.66191 23.0809V0.449219Z',
                        fill: '#223C72',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12 0.5C18.3512 0.5 23.4999 5.64869 23.5 12C23.5 18.3514 18.3513 23.501 12 23.501C5.64874 23.501 0.5 18.3514 0.5 12C0.500145 5.64869 5.64883 0.5 12 0.5Z',
                        stroke: 'white',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_21686_30736' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
